import { render, staticRenderFns } from "./NFCScannerComponent.vue?vue&type=template&id=497fdc6b"
import script from "./NFCScannerComponent.vue?vue&type=script&lang=js"
export * from "./NFCScannerComponent.vue?vue&type=script&lang=js"
import style0 from "./NFCScannerComponent.vue?vue&type=style&index=0&id=497fdc6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports